var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28003 0.219835C5.42054 0.079142 5.61118 9.45523e-06 5.81003 -0.000165527L6.19003 -0.000165493C6.38844 0.0021386 6.57831 0.0809507 6.72003 0.219835L11.85 5.35984C11.9447 5.45372 11.9979 5.58152 11.9979 5.71484C11.9979 5.84815 11.9447 5.97595 11.85 6.06984L11.14 6.77984C11.0479 6.8739 10.9217 6.92691 10.79 6.92691C10.6583 6.92691 10.5322 6.8739 10.44 6.77984L6.00003 2.32983L1.56003 6.77983C1.46614 6.87449 1.33834 6.92773 1.20503 6.92773C1.07171 6.92773 0.943909 6.87449 0.850025 6.77983L0.150025 6.06983C0.0553695 5.97595 0.00212679 5.84815 0.0021268 5.71483C0.00212681 5.58152 0.0553695 5.45372 0.150026 5.35983L5.28003 0.219835Z",
    fill: "#59626F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionIcon);
export default __webpack_public_path__ + "static/media/accordion-icon.74bbb39bc5c762de9844757f6aa78c0b.svg";
export { ForwardRef as ReactComponent };